<template lang='pug'>
.static-banner(
  :class="bannerBottomShowBigScreens ? 'mainWrapper-leftContent--counterBigScreens show--bigScreens' : 'show--smallScreens'"
  :style="'background-image: url(' + getImgURL('/image-static-bottom.jpg') +')'")
  .static-text1Banner.text--16 預防與杜絕
  .static-text2Banner.text--24 數位當責計畫
  a.static-buttonBanner(href="https://official-blog-tw.line.me/archives/17062125.html" target="_blank")
    span.text-18 暸解更多
    i.static-iconBanner.icon-caret-white
</template>
<script>
  import { getImgURL } from '@/plugins/tool.js'
export default {
  props: {
    bannerBottomShowBigScreens: Boolean
  },
  data() {
    return {
      getImgURL: getImgURL
    }
  }
}
</script>
